import { useEffect, useState } from "react";
import Quagga from '@ericblade/quagga2';
import { Button, Flex, Icon, Text } from "@chakra-ui/react";
import { FiX, FiCamera } from "react-icons/fi";

import { validIsbn } from "../../utils/validIsbn";

import { Video } from './styles';

interface ScannerProps {
	onRequestClose: (close: boolean) => void;
	handleCode: (code: string) => Promise<boolean>;
	device: string;
  devices: any[];
}
const ModalScanner: React.FC<ScannerProps> = ({
	onRequestClose,
	handleCode,
	device,
  devices,
}) => {
	// let scannerAttemps = 0;
  const [deviceUsed, setDeviceUsed] = useState(device);

	// const onDetected = (result: any) => {
  async function onDetected (result: any) {
		Quagga.offDetected(onDetected);

		const isbn = result.codeResult.code;

    if (isbn.length === 13) {
      const valid = validIsbn(isbn);

      if (valid) {
        const isClose = await handleCode(isbn);

        if (isClose) {
          await Quagga.stop();
          onRequestClose(false);
        }
      } /* else {
        if (scannerAttemps >= 5) {
          alert('Não foi possível ler o código de barras, por favor, tente novamente.');
        }
      } */
    }

    const isClose = await handleCode(isbn);

    if (isClose) {
      await Quagga.stop();
      onRequestClose(false);
    }

		// scannerAttemps++;
		Quagga.onDetected(onDetected);

		return isbn;
	}

  async function handleSetDevice(devicee: string) {
    if (navigator.mediaDevices && typeof navigator.mediaDevices.getUserMedia === 'function') {
      await Quagga.init({
        inputStream: {
          name: 'Live',
          type: 'LiveStream',
          size: 1920,
          singleChannel: false,
          // numOfWorkers: navigator.hardwareConcurrency,
          target: '#video',
          // target: document.querySelector('video'),
          // imageCapture: true,
          constraints: {
            width: 1920,
            height: 1080,
            facingMode: 'environment',
            deviceId: devicee,
          },
          /* photoSettings: {
            fillLightMode: "torch", // or "flash"
            focusMode: "continuous",
          }, */
        },
        locator: {
          patchSize: 'small',  // x-small, small, medium, large, x-large
          halfSample: true,
        },
        frequency: 10,
        locate: true,
        decoder: {
          readers: [
            "code_128_reader",
            "ean_reader",
            "ean_8_reader",
            "code_39_reader",
            "code_39_vin_reader",
            "codabar_reader",
            "upc_reader",
            "upc_e_reader",
            "i2of5_reader"
          ],
        },
      },
        (err: any) => {
          if (err) {
            console.error(err);
            alert(err);
            return;
          }
          Quagga.start();
        },
      );

      Quagga.onDetected(onDetected);
    }
  }

	useEffect(() => {
    handleSetDevice(device);
  }, [deviceUsed]);

	return (
		<>
      <Video id="video" />

      <Button
        position="absolute"
        top={2}
        right={2}
        p={0}
        opacity={0.60}
        backgroundColor="gray.200"
        borderRadius="full"
        zIndex="1000"
        _hover={{ background: 'gray.200', opacity: 1 }}
        _focus={{ background: 'gray.200', opacity: 1 }}
        onClick={async () => {
          await Quagga.stop();
          onRequestClose(false);
        }}
      >
        <Icon as={FiX} fontSize={25} color="white" />
      </Button>

      <Flex
        flexDir="column"
        position="absolute"
        top={2}
        left={2}
      >
        {/* <Flex
          color="white"
          opacity={10.50}
          backgroundColor="gray.200"
          borderRadius="full"
          zIndex="1000"
          p={1}
          mb={2}
        >
          <Text
            fontSize={9}
            color="white"
          >
            {deviceUsed}
          </Text>
        </Flex> */}

        {devices.map((deviceItem, indice) => {
          return (
            <Button
              key={deviceItem.deviceId + indice}
              p={0}
              mx={1}
              mb={2}
              zIndex="1000"
              opacity={deviceItem.deviceId === deviceUsed ? 1 : 0.50}
              backgroundColor="gray.200"
              color="white"
              borderRadius="full"
              _hover={{ background: 'gray.200', opacity: 1 }}
              _focus={{ background: 'gray.200', opacity: 1 }}
              onClick={async () => {
                if (deviceItem.deviceId !== deviceUsed) {
                  await Quagga.stop();
                  setDeviceUsed(deviceItem.deviceId);
                  // handleSetDevice(deviceItem.deviceId);
                }
              }}
            >
              <Flex flexDir="row" align="center">
                <Icon as={FiCamera} fontSize={17} color="white" />
                &nbsp;{indice +1}
                {/* <Text fontSize={9} color="white">{deviceItem.deviceId}</Text> */}
              </Flex>
            </Button>
          )
        })}
      </Flex>

			{/* <Container>
				<ScanMarker>
					<Image
						src=""
						alt="Marca para leitura do código"
						width={260}
						height={260}
					/>

					<p className="label">Aponte para o código de barras</p>
				</ScanMarker>

				<Image
					className="logo"
					src=""
					alt="RazioDigital"
					width={137}
					height={69}
				/>
			</Container> */}
		</>
	)
}

export default ModalScanner;

/*
<Flex
				bottom={50}
				position="absolute"
				zIndex="1000"
				flexDir="column"
			>
				{devices.map((item: any) => {
					return (
						<Text
							as="button"
							key={item.deviceId}
							color="blue.100"
							py={2}
							onClick={() => setCamera(item.deviceId)}
						>
							{item.deviceId}
						</Text>
					)
				})}
			</Flex>
*/
